import empty from "is-empty";
import { v4 as uuidv4 } from "uuid";
import { FileManager } from "./types";
import { FileManagerSelectors } from "./selectors";
import { Confirmations } from "src/redux/Confirmations/types";
import { SpinnerActions } from "src/redux/Spinner/actions";
import { AuthSelectors } from "src/redux/Auth/selectors";

// File storage stubs - S3/Amplify storage removed.
// TODO: Route file operations through backend API endpoints.
const remove = async () => { console.warn("File remove stubbed (S3 removed)"); };
const uploadData = (opts) => ({ result: Promise.resolve({ key: opts?.key }) });
const getUrl = async () => ({ url: { href: "#" } });
const downloadData = async () => ({ body: { blob: async () => new Blob() } });

export const FileManagerActions = {
    ResetFiles: (removeUploaded) => {
        //remove files on s3
        return async (dispatch, getState) => {
            const state = getState();
            if (removeUploaded) {
                let { files, uuid } =
                    FileManagerSelectors.GetUploadedFils(state);
                let { confirmationAttachmentsPath } =
                    AuthSelectors.GetAuthFiles(state);
                try {
                    files.forEach(async (file) => {
                        await remove({
                            key: `${confirmationAttachmentsPath}/${uuid}/${file}`,
                            options: { accessLevel: "protected" },
                        });
                    });
                } catch (err) {
                    console.log("Error uploading file: ", err);
                }
            }
            dispatch({
                type: FileManager.SET_UPLOADED_FILES,
                files: [],
                uuid: null,
            });
        };
    },

    InitializeUploadedFiles: () => {
        //remove files on s3
        return (dispatch) => {
            dispatch({
                type: FileManager.SET_UPLOADED_FILES,
                files: [],
                uuid: null,
            });
        };
    },

    RemoveFileFromS3: (index) => {
        return async (dispatch, getState) => {
            dispatch(SpinnerActions.Open());
            const state = getState();
            let { files, uuid } = FileManagerSelectors.GetUploadedFils(state);
            let { confirmationAttachmentsPath } =
                AuthSelectors.GetAuthFiles(state);
            try {
                const file = files.splice(index, 1);
                await remove({
                    key: `${confirmationAttachmentsPath}/${uuid}/${file[0]}`,
                    options: {
                        accessLevel: "protected",
                    },
                });
            } catch (err) {
                console.log("Error uploading file: ", err);
            }
            dispatch(SpinnerActions.Close());
            dispatch({ type: FileManager.SET_UPLOADED_FILES, files });
        };
    },

    UploadFileToS3: (fileList) => {
        return async (dispatch, getState) => {
            dispatch(SpinnerActions.Open());
            const state = getState();
            let { files, uuid } = FileManagerSelectors.GetUploadedFils(state);
            let { confirmationAttachmentsPath } =
                AuthSelectors.GetAuthFiles(state);
            if (!uuid) {
                // same per one upload moddal
                uuid = uuidv4();
            }
            let filesToUpload = [];
            try {
                for (let i = 0; i < fileList.length; i++) {
                    const file = fileList[i];
                    filesToUpload.push(file.name);
                    await uploadData({
                        key: `${confirmationAttachmentsPath}/${uuid}/${file.name}`,
                        data: file,
                        options: {
                            accessLevel: "protected",
                            contentType: file.type, // contentType is optional
                        },
                    }).result;
                }
            } catch (err) {
                console.log("Error uploading file: ", err);
            }
            dispatch(SpinnerActions.Close());
            dispatch({
                type: FileManager.SET_UPLOADED_FILES,
                files: files.concat(filesToUpload),
                uuid,
            });
        };
    },

    BuildConfirmationAttachmentsPath: (confirmation) => {
        return async (dispatch, getState) => {
            const result = { ...confirmation };
            const state = getState();
            let { confirmationAttachmentsPath } =
                AuthSelectors.GetAuthFiles(state);
            // TODO: Get str from confirmation.attachments
            if (!empty(confirmation.attachments)) {
                const filePaths = confirmation.attachments.split(",");
                let attachments = [];
                for (let i = 0; i < filePaths.length; i++) {
                    const url = await getUrl({
                        key: `${confirmationAttachmentsPath}/${filePaths[i]}`,
                        options: { accessLevel: "protected" },
                    });
                    attachments.push({ path: filePaths[i], url });
                }
                result.attachments = attachments;
            }
            dispatch({
                type: Confirmations.SELECT_CONFIRMATION,
                confirmation: result,
            });
        };
    },

    downloadFile: (filePath) => {
        return async (dispatch, getState) => {
            try {
                const state = getState();
                let { confirmationAttachmentsPath } =
                    AuthSelectors.GetAuthFiles(state);
                const { body } = await downloadData({
                    key: `${confirmationAttachmentsPath}/${filePath}`,
                    options: { accessLevel: "protected" },
                }).result;
                return body;
            } catch (error) {
                console.error("Error in downloadFile:", error.message);
                return null; // propagates null forward to use to know file download failed
            }
        };
    },
};
